import { render, staticRenderFns } from "./PersonalDashboard.vue?vue&type=template&id=f2d57e90&"
import script from "./PersonalDashboard.vue?vue&type=script&lang=js&"
export * from "./PersonalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDashboard.vue?vue&type=style&index=0&id=f2d57e90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports